import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from './CTAButton';
import { PRICE } from './salesData';
import { trackInitiateCheckout } from '../utils/metaPixel';

/**
 * Barra de compra fija para móvil. Aparece una vez que el hero quedó atrás y
 * se oculta al llegar al footer para no interferir con la navegación.
 */
export function StickyBuyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const scrolledPastHero = window.scrollY > window.innerHeight * 0.85;
      const footer = document.getElementById('site-footer');
      const footerReached = footer ? footer.getBoundingClientRect().top <= window.innerHeight : false;
      setVisible(scrolledPastHero && !footerReached);
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-stone bg-white/95 backdrop-blur transition-transform duration-300 ease-out md:hidden ${visible ? 'translate-y-0' : 'pointer-events-none translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-207" data-mp="2iemeb7mcmjwf">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-208" data-mp="323ezbtf2yyoq">
        <div className="min-w-0" data-id="element-209" data-mp="3246mqgyixq3x">
          <p className="truncate font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-taupe" data-id="element-210" data-mp="364qef50bw1io">
            Postres que Venden™
          </p>
          <div className="flex items-baseline gap-1.5" data-id="element-211" data-mp="17r6yjzg2vnl1">
            <p className="font-display text-[1.4rem] font-extrabold leading-none tracking-tight tabular-nums text-charcoal" data-id="element-212" data-mp="1bq7d35riw428">
              {PRICE.current}
            </p>
            <p className="font-sans text-[0.7rem] tabular-nums text-taupe/70" style={{
            textDecoration: 'line-through'
          }} data-id="element-213" data-mp="2a2s2l1tuuzmu">
              {PRICE.previous}
            </p>
          </div>
        </div>
        <a href={CHECKOUT_URL} onClick={() => trackInitiateCheckout()} tabIndex={visible ? 0 : -1} className="cta-gradient flex min-h-[48px] max-w-[11rem] shrink-0 items-center justify-center rounded-xl px-5 py-2 text-center font-display text-[0.8rem] font-bold uppercase leading-[1.15] tracking-[0.03em] text-white shadow-[0_12px_26px_-12px_rgba(232,62,115,0.8)] transition-transform duration-200 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-214" data-mp="2jzwr38b6b76t">
          Quiero empezar
        </a>
      </div>
    </div>;
}